// This component provides a redirect mechanism for specific activities or trainers in a designated course.
// It maps activity/trainer IDs from one course to another to fix functionality with existing QR codes in printed books.
import { ReactElement } from "react";
import { Navigate, useParams } from "react-router-dom";

import useCourse from "@hooks/useCourse";

import CenteredSpinner from "@topgun/shared-front-end/src/components/CenteredSpinner/index";

// Rijbewijs B - BOEK- online oefenen (alle oefenmodules)
const COURSE_ID = "a3624115-5836-4dff-a74e-2bbed0a95b0b";

// These are the mappings between content where the book links to and the content of the course above.
const ACTIVITY_MAP = new Map<string, string>([
  ["9914bdf9-4c3c-4d35-83fc-cc8c7755d9fd", "a9af7735-f613-44bc-a1e1-7356fb90b1e0"],
]);

const TRAINER_MAP = new Map<string, string>([
  ["df605676-5c8a-49b9-8520-2db405b5e5ff", "aa08288c-f4dc-4ac0-9b0d-596fea425ecb"],
  ["65e13203-c546-403d-8322-66fdeaaf9fc1", "246f7406-9a19-45e4-ae1c-a55ba040e87d"],
  ["5a08fb0d-be7d-4d99-98cd-c35d140494de ", "1c53913d-710b-48cc-a07b-780a06e8e7cc"],
  ["ddfb076d-dbfe-440c-a9f3-6b56dc0ef3d9 ", "78f07a06-5d71-4aee-bf1b-e94a7891dc2e"],
  ["8b57cc99-dab8-4364-aa2e-017e0aad3b9b", "0f2ffc96-a7c5-4f05-9a27-6245148dad99"],
  ["a4cd14cb-7a8c-414d-9cff-79f8f2ca0517", "5d868909-0b25-43d8-886f-c4679d05ef65"],
  ["80942467-cdbb-4a38-9af4-915fdc75db28", "f984d3a1-c4b6-439e-a6e7-e0a18caed75e"],
  ["784e8879-45a5-4060-83e6-e26722463a22", "3eaf59ba-4df8-450a-b073-20320614f8f4"],
  ["ea451379-6988-4c28-8471-c47fe5eee461", "6cb23560-4fc3-4ce7-84b2-a5c51215583c"],
  ["0f68431b-051f-44ea-8412-fac78aeabf8d", "a351aec3-a6e1-45e6-b751-5192c91bb04b"],
  ["3208ba7c-d330-406c-9d81-c0d511736e5f", "8765e5d2-b8e9-4b89-bb42-46929604362d"],
]);

export default function QrBookRedirect({ children }: { children: ReactElement }) {
  const { activityId, configurationId } = useParams();
  const { course, isLoading } = useCourse();

  if (isLoading) {
    return <CenteredSpinner />;
  }

  if (COURSE_ID === course?.value.id) {
    if (activityId && ACTIVITY_MAP.has(activityId)) {
      return <Navigate to={`/activities/${ACTIVITY_MAP.get(activityId)}`} replace />;
    }
    if (configurationId && TRAINER_MAP.has(configurationId)) {
      return <Navigate to={`/trainers/${TRAINER_MAP.get(configurationId)}`} replace />;
    }
  }

  return children;
}
